import type { PractitionerPublicListDto, PractitionerPublicProfileDto } from "cmw-client";

/**
 * Offset pages can overlap when the backend order shifts between requests, so a practitioner
 * already shown is kept where it first appeared and any later repeat is dropped.
 */
export const uniquePractitioners = (
  pages: Pick<PractitionerPublicListDto, "items">[],
): PractitionerPublicProfileDto[] => {
  const seen = new Set<string>();

  return pages
    .flatMap((page) => page.items)
    .filter(({ username }) => !seen.has(username) && seen.add(username));
};
